import Vue from 'vue'
import datatable from '@/components/datatable'
import infoalert from '@/components/info_alert'
import divider from '@/components/divider'
import tags from '@/components/tags'
import chooseCustomer from '@/components/choose_customer'
import chooseProj from '@/components/choose_proj'
import insertCustomer from '@/components/insert_customer'
import chooseUser from '@/components/choose_user'
import selectDropdown from '@/components/dropdowns'
import customerCheckbox from '@/components/checkbox'
Vue.component('datatable', datatable)
Vue.component('info_alert', infoalert)
Vue.component('divider', divider)
Vue.component('tags', tags)
Vue.component('chooseCustomer', chooseCustomer)
Vue.component('insertCustomer', insertCustomer)
Vue.component('chooseUser', chooseUser)
Vue.component('chooseProj', chooseProj)
Vue.component('select-dropdown', selectDropdown)
Vue.component('customize-checkbox', customerCheckbox)



// WEBPACK FOOTER //
// ./src/import-component.js